<template>
  <v-layout>
    <v-flex xs12>
      <v-data-table
        class="elevation-3 separate-columns"
        item-key="provisionId"
        :headers="headers"
        :items="statistics"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50, 100, -1],
        }"
        @current-items="getFilteredStatistics"
      >
        <template v-slot:[`body.prepend`]="{ isMobile }">
          <tr>
            <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
              <v-autocomplete
                clearable
                height="25"
                color="secondary"
                v-model.trim="filterPointAddress"
                label="Пункт доставки"
                :items="points"
                item-text="item"
                item-value="value"
              ></v-autocomplete>
            </td>
            <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
              <v-text-field
                clearable
                height="25"
                color="secondary"
                v-model="filterManufacturer"
                label="Производитель"
              ></v-text-field>
            </td>
            <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
              <v-text-field
                clearable
                height="25"
                color="secondary"
                v-model="filterProductName"
                label="Наименование"
              ></v-text-field>
            </td>
          </tr>
        </template>

        <template v-slot:[`item.start`]="{ item }">
          {{ item.start | date }}
        </template>

        <template v-slot:[`item.end`]="{ item }">
          {{ item.end | date }}
        </template>

        <template v-slot:[`item.orderPrice`]="{ item }">
          {{ item.orderPrice | twoDecimalPoint }}
        </template>

        <template v-slot:[`item.progressPrice`]="{ item }">
          <v-progress-circular
            color="primary"
            :rotate="-90"
            :size="60"
            :width="5"
            :value="item.progressPrice"
            v-if="item.provisionPrice > 0"
          >
            {{ item.progressPrice }}
          </v-progress-circular>
        </template>

        <template v-slot:[`item.progressQuantity`]="{ item }">
          <v-progress-circular
            color="primary"
            :rotate="-90"
            :size="60"
            :width="5"
            :value="item.progressQuantity"
            v-if="item.provisionQuantity > 0"
          >
            {{ item.progressQuantity }}
          </v-progress-circular>
        </template>

        <template v-slot:no-data>
          <v-alert :value="true" type="warning">Записи не найдены</v-alert>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
// import { Icon } from "@/helpers";

export default {
  props: {
    statistics: {
      type: Array,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "Пункт доставки",
          value: "pointAddress",
          filter: (value) => {
            if (this.filterPointAddress !== null)
              if (!this.filterPointAddress) return true;

            // return value.search(new RegExp(this.filterPointAddress, "i")) > -1;
            return value === this.filterPointAddress;
          },
        },
        {
          text: "Производитель",
          value: "manufacturer",
          filter: (value) => {
            if (!this.filterManufacturer) return true;

            return value.search(new RegExp(this.filterManufacturer, "i")) > -1;
          },
        },
        {
          text: "Наименование",
          value: "productName",
          filter: (value) => {
            if (!this.filterProductName) return true;

            if (value != null)
              return value.search(new RegExp(this.filterProductName, "i")) > -1;
          },
        },
        {
          text: "Дата начала",
          value: "start",
          align: "center",
          // width: "8%"
        },
        {
          text: "Дата завершения",
          value: "end",
          align: "center",
          // width: "8%"
        },
        {
          text: "План на период, РОЦ руб.",
          value: "provisionPrice",
          align: "right",
          // width: "8%"
        },
        {
          text: "План на период, шт.",
          value: "provisionQuantity",
          align: "right",
          // width: "8%"
        },
        {
          text: "Факт закупок, РОЦ руб.",
          value: "orderPrice",
          align: "right",
          // width: "9%"
        },
        {
          text: "Факт закупок, шт.",
          value: "orderQuantity",
          align: "right",
          // width: "9%"
        },
        {
          text: "% выполнения плана, РОЦ руб.",
          value: "progressPrice",
          align: "center",
        },
        {
          text: "% выполнения плана, шт.",
          value: "progressQuantity",
          align: "center",
        },
      ];
    },
    points: function () {
      // return [...new Set(this.statistics.map(x => x.pointAddress))].sort();
      const result = [];
      const map = new Map();
      for (const item of this.statistics) {
        if (!map.has(item.pointAddress)) {
          map.set(item.pointAddress, true);
          result.push({
            item: item.pointAddress === null ? "" : item.pointAddress,
            value: item.pointAddress,
          });
        }
      }

      return result.reverse();
    },
  },
  methods: {
    getFilteredStatistics: function (items) {
      this.$emit("filtered-statistics", items);
    },
  },
  data: () => ({
    filterPointAddress: "",
    filterManufacturer: "",
    filterProductName: "",
    icons: {},
  }),
  mounted: async function () {},
};
</script>
